import React from 'react';

const Header = () => (
  <header style={headerStyles.header}>
    <div style={headerStyles.left}>
      <span style={headerStyles.logoIcon}>🦉</span>
      <span style={headerStyles.logoText}>HOOTLAND</span>
    </div>
    <div style={headerStyles.center}>
      <a href="/mint" style={headerStyles.link}>Mint Agents →</a>
      <a href="/world" style={headerStyles.link}>World →</a>
      <a href="/about" style={headerStyles.link}>About →</a>
      <a href="/tokenomics" style={headerStyles.link}>Tokenomics →</a>
    </div>
    <div style={headerStyles.right}>
      <a href="/" style={headerStyles.backLink}>← Back</a>
    </div>
  </header>
);

export default function Tokenomics() {
  return (
    <div style={styles.container}>
      <Header />
      <div style={styles.content}>
        <h1 style={styles.title}>Tokenomics</h1>
        
        <section style={styles.section}>
          <h2 style={styles.heading}>owlSDT Token</h2>
          <div style={styles.tokenInfo}>
            <div style={styles.tokenDetail}>
              <span style={styles.label}>Symbol</span>
              <span style={styles.value}>owlSDT</span>
            </div>
            <div style={styles.tokenDetail}>
              <span style={styles.label}>Total Supply</span>
              <span style={styles.value}>1,000,000,000</span>
            </div>
            <div style={styles.tokenDetail}>
              <span style={styles.label}>Decimals</span>
              <span style={styles.value}>18</span>
            </div>
            <div style={styles.tokenDetail}>
              <span style={styles.label}>Network</span>
              <span style={styles.value}>Base Mainnet</span>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Earning Mechanics</h2>
          <p style={styles.text}>
            Agents earn owlSDT passively based on their tier multiplier.
            The base earning rate is 10 owlSDT per hour, multiplied by the agent's tier.
          </p>
          <div style={styles.formula}>
            <code style={styles.code}>
              earnings = baseRate × hours × multiplier / 100
            </code>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Tier Multipliers</h2>
          <div style={styles.table}>
            <div style={styles.row}>
              <span style={styles.cell}>Tier</span>
              <span style={styles.cell}>Multiplier</span>
              <span style={styles.cell}>OWL/hr</span>
              <span style={styles.cell}>Drop Rate</span>
            </div>
            <div style={styles.row}>
              <span style={styles.cell}>Agent</span>
              <span style={styles.cell}>1.2x</span>
              <span style={styles.cell}>12</span>
              <span style={styles.cell}>50%</span>
            </div>
            <div style={styles.row}>
              <span style={styles.cell}>Sentinel</span>
              <span style={styles.cell}>1.5x</span>
              <span style={styles.cell}>15</span>
              <span style={styles.cell}>30%</span>
            </div>
            <div style={styles.row}>
              <span style={styles.cell}>Overseer</span>
              <span style={styles.cell}>2.0x</span>
              <span style={styles.cell}>20</span>
              <span style={styles.cell}>15%</span>
            </div>
            <div style={styles.row}>
              <span style={styles.cell}>Elder</span>
              <span style={styles.cell}>3.0x</span>
              <span style={styles.cell}>30</span>
              <span style={styles.cell}>5%</span>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Minting Prices</h2>
          <div style={styles.prices}>
            <div style={styles.price}>
              <span style={styles.priceLabel}>Early Bird</span>
              <span style={styles.priceAmount}>0.0001 ETH</span>
              <span style={styles.priceRange}>Agents 1-1,000</span>
            </div>
            <div style={styles.price}>
              <span style={styles.priceLabel}>Growth</span>
              <span style={styles.priceAmount}>0.001 ETH</span>
              <span style={styles.priceRange}>Agents 1,001-10,000</span>
            </div>
            <div style={styles.price}>
              <span style={styles.priceLabel}>Main</span>
              <span style={styles.priceAmount}>0.01 ETH</span>
              <span style={styles.priceRange}>Agents 10,001-25,000</span>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Resource Gathering</h2>
          <div style={styles.resources}>
            <div style={styles.resource}>
              <span style={styles.resourceIcon}>🪵</span>
              <span style={styles.resourceName}>Wood</span>
              <span style={styles.resourceBonus}>+10% bonus</span>
            </div>
            <div style={styles.resource}>
              <span style={styles.resourceIcon}>🪨</span>
              <span style={styles.resourceName}>Stone</span>
              <span style={styles.resourceBonus}>+20% bonus</span>
            </div>
            <div style={styles.resource}>
              <span style={styles.resourceIcon}>🪙</span>
              <span style={styles.resourceName}>Gold</span>
              <span style={styles.resourceBonus}>+50% bonus</span>
            </div>
            <div style={styles.resource}>
              <span style={styles.resourceIcon}>🍎</span>
              <span style={styles.resourceName}>Food</span>
              <span style={styles.resourceBonus}>+15% bonus</span>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#07070f',
    color: '#e2e8f0',
    padding: '40px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    overflowY: 'auto',
    maxHeight: '100vh',
  },
  content: {
    maxWidth: 800,
    margin: '0 auto',
  },
  title: {
    fontSize: 42,
    fontWeight: 700,
    color: '#7eb8f7',
    marginBottom: 40,
    textAlign: 'center',
  },
  section: {
    marginBottom: 48,
  },
  heading: {
    fontSize: 24,
    fontWeight: 600,
    color: '#7eb8f7',
    marginBottom: 20,
  },
  text: {
    fontSize: 16,
    lineHeight: 1.7,
    color: '#94a3b8',
  },
  tokenInfo: {
    background: 'rgba(126,184,247,0.06)',
    border: '1px solid rgba(126,184,247,0.15)',
    borderRadius: 12,
    padding: 20,
  },
  tokenDetail: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 0',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
  },
  label: {
    fontSize: 14,
    color: '#94a3b8',
  },
  value: {
    fontSize: 14,
    fontWeight: 600,
    color: '#e2e8f0',
  },
  formula: {
    background: 'rgba(0,0,0,0.3)',
    padding: 16,
    borderRadius: 8,
    marginTop: 16,
  },
  code: {
    fontFamily: 'monospace',
    color: '#7eb8f7',
    fontSize: 14,
  },
  table: {
    background: 'rgba(255,255,255,0.03)',
    borderRadius: 12,
    overflow: 'hidden',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    padding: '16px',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
  },
  cell: {
    fontSize: 14,
  },
  prices: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: 16,
  },
  price: {
    background: 'rgba(126,184,247,0.06)',
    border: '1px solid rgba(126,184,247,0.15)',
    borderRadius: 12,
    padding: 20,
    textAlign: 'center',
  },
  priceLabel: {
    fontSize: 14,
    color: '#94a3b8',
    marginBottom: 8,
    display: 'block',
  },
  priceAmount: {
    fontSize: 24,
    fontWeight: 700,
    color: '#fbbf24',
    marginBottom: 8,
    display: 'block',
  },
  priceRange: {
    fontSize: 12,
    color: '#64748b',
  },
  resources: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: 16,
  },
  resource: {
    background: 'rgba(255,255,255,0.03)',
    borderRadius: 12,
    padding: 20,
    textAlign: 'center',
  },
  resourceIcon: {
    fontSize: 32,
    marginBottom: 8,
    display: 'block',
  },
  resourceName: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 4,
    display: 'block',
  },
  resourceBonus: {
    fontSize: 12,
    color: '#fbbf24',
  },
};

const headerStyles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    background: 'rgba(0,0,0,0.8)',
    borderBottom: '1px solid rgba(126,184,247,0.15)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  logoIcon: {
    fontSize: 24,
  },
  logoText: {
    fontSize: 18,
    fontWeight: 700,
    color: '#7eb8f7',
  },
  center: {
    display: 'flex',
    gap: 24,
  },
  link: {
    color: '#94a3b8',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 500,
    transition: 'color 0.2s',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
  },
  backLink: {
    color: '#7eb8f7',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 500,
  },
};
